import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface CallToActionProps {
  currentLanguage: string;
}

const CallToAction: React.FC<CallToActionProps> = ({ currentLanguage }) => {
  const content = {
    en: {
      title: 'Join Our Mission of Service',
      subtitle: 'Every contribution makes a difference in preserving dharma and serving humanity',
      donate: {
        title: 'Make a Donation',
        description: 'Support our programs and help us reach more people in need',
        button: 'Donate Now',
        icon: 'HeartIcon'
      },
      volunteer: {
        title: 'Become a Volunteer',
        description: 'Share your time and skills to serve the community',
        button: 'Join Us',
        icon: 'UserGroupIcon'
      },
      learn: {
        title: 'Learn Dharma',
        description: 'Explore our educational programs and spiritual teachings',
        button: 'Explore Programs',
        icon: 'AcademicCapIcon'
      }
    },
    hi: {
      title: 'हमारे सेवा मिशन में शामिल हों',
      subtitle: 'हर योगदान धर्म को संरक्षित करने और मानवता की सेवा करने में अंतर लाता है',
      donate: {
        title: 'दान करें',
        description: 'हमारे कार्यक्रमों का समर्थन करें और जरूरतमंद लोगों तक पहुंचने में हमारी मदद करें',
        button: 'अभी दान करें',
        icon: 'HeartIcon'
      },
      volunteer: {
        title: 'स्वयंसेवक बनें',
        description: 'समुदाय की सेवा के लिए अपना समय और कौशल साझा करें',
        button: 'हमसे जुड़ें',
        icon: 'UserGroupIcon'
      },
      learn: {
        title: 'धर्म सीखें',
        description: 'हमारे शैक्षिक कार्यक्रमों और आध्यात्मिक शिक्षाओं का अन्वेषण करें',
        button: 'कार्यक्रम देखें',
        icon: 'AcademicCapIcon'
      }
    }
  };

  const text = currentLanguage === 'hi' ? content.hi : content.en;

  const actions = [
    {
      ...text.donate,
      href: '/donation',
      bgColor: 'bg-primary',
      hoverColor: 'hover:bg-brand-saffron'
    },
    {
      ...text.volunteer,
      href: '/services',
      bgColor: 'bg-secondary',
      hoverColor: 'hover:bg-brand-green'
    },
    {
      ...text.learn,
      href: '/about',
      bgColor: 'bg-accent',
      hoverColor: 'hover:bg-brand-gold'
    }
  ];

  return (
    <section data-component-id="src/app/homepage/components/CallToAction.tsx:81:4" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="81" data-component-end-line="121" data-component-file="CallToAction.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-20%20bg-gradient-to-br%20from-primary%2F10%20via-accent%2F10%20to-secondary%2F10%22%7D" className="py-20 bg-gradient-to-br from-primary/10 via-accent/10 to-secondary/10">
      <div data-component-id="src/app/homepage/components/CallToAction.tsx:82:6" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="82" data-component-end-line="120" data-component-file="CallToAction.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%22%7D" className="container mx-auto px-4">
        <div data-component-id="src/app/homepage/components/CallToAction.tsx:83:8" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="83" data-component-end-line="90" data-component-file="CallToAction.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-12%22%7D" className="text-center mb-12">
          <h2 data-component-id="src/app/homepage/components/CallToAction.tsx:84:10" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="84" data-component-end-line="86" data-component-file="CallToAction.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-headline%20text-3xl%20md%3Atext-4xl%20font-bold%20text-foreground%20mb-3%22%7D" className="font-headline text-3xl md:text-4xl font-bold text-foreground mb-3">
            {text.title}
          </h2>
          <p data-component-id="src/app/homepage/components/CallToAction.tsx:87:10" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="87" data-component-end-line="89" data-component-file="CallToAction.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted-foreground%20font-accent%20max-w-2xl%20mx-auto%22%7D" className="text-muted-foreground font-accent max-w-2xl mx-auto">
            {text.subtitle}
          </p>
        </div>

        <div data-component-id="src/app/homepage/components/CallToAction.tsx:92:8" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="92" data-component-end-line="119" data-component-file="CallToAction.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20md%3Agrid-cols-3%20gap-8%20max-w-6xl%20mx-auto%22%7D" className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {actions.map((action, index) => (
            <div data-component-id="src/app/homepage/components/CallToAction.tsx:94:12" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="94" data-component-end-line="117" data-component-file="CallToAction.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20rounded-xl%20p-8%20text-center%20dharmic-shadow%20hover%3Ashadow-xl%20transition-all%20duration-300%20transform%20hover%3Ascale-105%22%7D"
              key={index}
              className="bg-card rounded-xl p-8 text-center dharmic-shadow hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              <div data-component-id="src/app/homepage/components/CallToAction.tsx:98:14" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="98" data-component-end-line="100" data-component-file="CallToAction.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`inline-flex items-center justify-center w-20 h-20 ${action.bgColor} rounded-full mb-6`}>
                <Icon data-component-id="src/app/homepage/components/CallToAction.tsx:99:16" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="99" data-component-end-line="99" data-component-file="CallToAction.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-white%22%7D" name={action.icon as any} size={40} variant="solid" className="text-white" />
              </div>

              <h3 data-component-id="src/app/homepage/components/CallToAction.tsx:102:14" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="102" data-component-end-line="104" data-component-file="CallToAction.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-headline%20text-2xl%20font-bold%20text-foreground%20mb-3%22%7D" className="font-headline text-2xl font-bold text-foreground mb-3">
                {action.title}
              </h3>

              <p data-component-id="src/app/homepage/components/CallToAction.tsx:106:14" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="106" data-component-end-line="108" data-component-file="CallToAction.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-muted-foreground%20mb-6%20leading-relaxed%22%7D" className="text-muted-foreground mb-6 leading-relaxed">
                {action.description}
              </p>

              <Link data-component-id="src/app/homepage/components/CallToAction.tsx:110:14" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="110" data-component-end-line="116" data-component-file="CallToAction.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
                href={action.href}
                className={`inline-flex items-center space-x-2 px-6 py-3 ${action.bgColor} text-white font-cta rounded-md ${action.hoverColor} transition-all duration-300 shadow-md hover:shadow-lg`}
              >
                <span data-component-id="src/app/homepage/components/CallToAction.tsx:114:16" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="114" data-component-end-line="114" data-component-file="CallToAction.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{action.button}</span>
                <Icon data-component-id="src/app/homepage/components/CallToAction.tsx:115:16" data-component-path="src/app/homepage/components/CallToAction.tsx" data-component-line="115" data-component-end-line="115" data-component-file="CallToAction.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ArrowRightIcon%22%7D" name="ArrowRightIcon" size={20} variant="outline" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
